import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.focus()
  }

  hide(event) {
    if (event) event.preventDefault()
    this.element.remove()
  }

  hideOnSubmit(event) {
    if (event.detail.success) {
      this.hide()
    }
  }

  disconnect() {
    const frame = document.querySelector("turbo-frame[id='modal']")
    if (frame) {
      frame.removeAttribute("src")
    }
  }
}
